import { change as changeFieldAction } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';

import * as constants from '../../helpers/constants';
import ActivationFormSimData from '../../components/compositions/activation/ActivationFormMsisdn';
import SimCardMarketError from '../../model/errors/SimCardMarketError';
import initForm from '../form/FormInitializer';
import * as tariffForm from './formConfigActivationTariff';
import {
  showMmoSimActivationTransferDialog,
  showSimActivationInProgressDialog,
} from '../../actions/dialog/misc';
import { send } from '../../actions/request/send';
import SimStatusRequest from '../../model/requests/SimStatusRequest';

const createFieldMap = ui => ({
  msisdn: {
    name: 'msisdn',
    label: ui.afoMsisdn,
    type: 'tel',
    validation: {
      isRequired: true,
      pattern: 'phone',
    },
  },
  activationCode: {
    name: 'sim_number',
    label: ui.afoActivationCode,
    validation: {
      isRequired: true,
      pattern: 'simNumber',
    },
  },
  market: {
    name: 'market',
    shouldSubmit: false,
  },
  simStatusResponse: {
    name: constants.FORM_FIELD_SIM_STATUS,
    shouldSubmit: false,
  },
  topupStatus: {
    name: constants.FORM_FIELD_TOPUP_OPTIONS,
    shouldSubmit: false,
  },
});

export const id = 'simData';

/**
 * Submit is successful if
 * (a) response is not an error
 * (b) sim status contained in the response is "PRE" or the market is 'MMO'.
 *
 * @todo maybe split makeSubmit in preSubmit and postSubmit and connect functions
 *       via promises. the idea is to avoid sideaffects in handleSubmit (e.g. setting
 *       form fields). {@link https://git.db-n.com/otelo/otelo-mvc/merge_requests/1397#note_18124}
 */
const makeSubmit = (stepConfig, props) => async (values, dispatch) => {
  const { form, fieldMap } = props;
  const msisdnField = fieldMap.msisdn.name;
  const msisdn = values[msisdnField];
  const marketField = fieldMap.market.name;
  const activationCodeField = fieldMap.activationCode.name;
  const activationCode = values[activationCodeField];

  // in any case, clear the current market
  dispatch(changeFieldAction(form, marketField, ''));

  const simStatusResponse = (await dispatch(
    send(new SimStatusRequest(
      { activationCode, msisdn },
    )))).body.data;

  const {
    market,
    topups,
    freeSimExchangeAvailable,
    webIdentInProgress,
  } = simStatusResponse;

  if (market !== constants.MARKET_PREPAID && market !== constants.MARKET_MMO) {
    throw new SimCardMarketError();
  }

  if (market === constants.MARKET_MMO && freeSimExchangeAvailable && !webIdentInProgress) {
    dispatch(showMmoSimActivationTransferDialog(simStatusResponse));
    return id;
  }

  if (webIdentInProgress) {
    const shouldContinue = await dispatch(
      showSimActivationInProgressDialog(simStatusResponse),
    );
    if (!shouldContinue) {
      return id;
    }
  }

  dispatch(changeFieldAction(form, marketField, market));
  dispatch(changeFieldAction(form, constants.FORM_FIELD_SIM_STATUS, simStatusResponse));
  dispatch(changeFieldAction(form, constants.FORM_FIELD_TOPUP_OPTIONS, topups));

  return tariffForm.id;
};

const mapStateToProps = ({ user }, { fieldMap }) => {
  if (user.pplus) {
    return {
      initialValues: {
        [fieldMap.msisdn.name]: user.pplus.msisdn,
      },
    };
  }
  return {};
};

const component = compose(
  connect(mapStateToProps),
  initForm(),
)(ActivationFormSimData);

/**
 * @return {FormConfig}
 */
export const mapStateToFormConfig = (state, props) => ({
  component,
  fieldMap: createFieldMap(props.ui),
  makeSubmit,
  label: props.ui.guiFormMsisdn,
});

export default mapStateToFormConfig;
